import { Config } from '../Config.js';
import { ENVIRONMENT } from '../types/EnvironmentType.js';
/**
 * Determines whether the current environment is the dev environment.
 *
 * @return {boolean}
 */ export var isDevEnvironment = function isDevEnvironment() {
    return Config.env === ENVIRONMENT.dev;
};

//# sourceMappingURL=isDevEnvironment.js.map